module.exports = __webpack_public_path__ + "static/media/pacifier_icon_small.8234cd23.png";